module.exports = __webpack_public_path__ + "fonts/2331392143b9220273048962bcab2f11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/vehicle.svg
// module id = 623
// module chunks = 0